import { useQuery } from 'react-query'
import { getIntegrationsForCustomer } from 'services/cm-api/get-integrations-for-customer'

export function useGetIntegrationsForCustomer(customerId: string) {
  return useQuery(
    ['useGetIntegrationsForCustomer'],
    () => getIntegrationsForCustomer(customerId),
    {},
  )
}
